<template>
  <CContainer fluid>
    <CCard>
      <CCardBody>
        <CTabs variant="pills" :vertical="vertical">
          <CTab active>
            <template slot="title"> Password </template>
            <ChangePasswordComponent :customTitle="`Change Password`" show />
          </CTab>
          <CTab>
            <template slot="title"> 2FA </template>
            <Setup2FAComponent :customTitle="`Setup 2FA`" show />
          </CTab>
          <!-- <CTab>
            <template slot="title">
              <CIcon name="cil-chart-pie" /> Tab 3
            </template>
            3. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </CTab> -->
        </CTabs>
      </CCardBody>
    </CCard>
  </CContainer>
</template>

<script>
import ChangePasswordComponent from '@/components/ChangePasswordComponent';
import Setup2FAComponent from '@/components/Setup2FAComponent';

export default {
  name: 'Settings',
  components: {
    ChangePasswordComponent,
    Setup2FAComponent,
  },
  data() {
    return {
      vertical: { navs: 'col-sm-2', content: 'col-sm-10' },
    };
  },
  mounted() {},
  methods: {},
};
</script>
